// extracted by mini-css-extract-plugin
module.exports = {"container":"BreadCrumbs_container__ZJ1XY","contant":"BreadCrumbs_contant__NJCK2","breadcrumb":"BreadCrumbs_breadcrumb__0fJXV","current":"BreadCrumbs_current__OUB2g"};